import type { FC } from "react";
import React from "react";
import {
  Box,
  Pagination as MuiPagination,
  Typography,
  Select,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useTheme, withStyles } from "@mui/styles";
import { paginationSelectStyles, paginationStyles } from "../../styles";

export type Props = {
  count: number;
  onChangePage: (arg0: number) => unknown;
  onChangePageSize: (arg0: number) => unknown;
  page: number;
  pageSize: number;
  isLoading?: boolean;
  rowsPerPage?: number[];
};
const defaultRowsPerPage: number[] = [10, 25, 50, 100];
const RowsPerPageSelect = withStyles(paginationSelectStyles)(Select);
const PaginationStyled = withStyles(paginationStyles)(MuiPagination);

const Pagination: FC<Props> = ({
  isLoading,
  page,
  pageSize,
  count,
  onChangePage,
  onChangePageSize,
  rowsPerPage = defaultRowsPerPage,
}) => {
  const theme: any = useTheme();
  const lg: boolean = useMediaQuery(theme.breakpoints.down("lg"));
  const xl: boolean = useMediaQuery(theme.breakpoints.down("xl"));
  let siblingCount = 3;

  if (xl) {
    siblingCount = 1;
  }

  if (lg) {
    siblingCount = 0;
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      data-testid="tablePaginationBlock"
      sx={{
        marginTop: "auto",
        paddingTop: "20px",
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
        }}
      >
        <Typography
          component="p"
          sx={{
            typography: {
              xs: "subtext",
              lg: "body",
            },
            mr: {
              xs: "10px",
              lg: "20px",
            },
          }}
        >
          Rows per page:&nbsp;
        </Typography>
        <RowsPerPageSelect
          data-testid="rowsperpage"
          disableUnderline
          variant="standard"
          value={pageSize}
          disabled={isLoading}
          onChange={(e: any) => {
            onChangePageSize(parseInt(e.target.value, 10));
            onChangePage(1);
          }}
        >
          {rowsPerPage.map((option: number) => (
            <MenuItem key={String(option)} value={option}>
              {option}
            </MenuItem>
          ))}
        </RowsPerPageSelect>
      </Box>
      <PaginationStyled
        siblingCount={siblingCount}
        boundaryCount={1}
        disabled={isLoading}
        page={page}
        count={Math.ceil(count / pageSize)}
        shape="rounded"
        onChange={(_: any, newPage: number): unknown => onChangePage(newPage)}
      />
      <Typography
        component="p"
        sx={{
          typography: {
            xs: "subtext",
            lg: "body",
          },
          display: {
            xs: "none",
            md: "flex",
          },
        }}
      >
        Results: 
        {" "}
        {count === 0 ? 0 : (page - 1) * pageSize || 1}
        -
        {count === 0 ? 0 : page * pageSize}
        {" of "}
        {count}
      </Typography>
    </Box>
  );
};

export default Pagination;
